import { useNavigate } from 'react-router-dom';

const blogPosts = [
  {
    title: 'How to Choose the Right Education Consultancy for Studying Abroad',
    excerpt: 'Finding the right consultancy can make or break your study abroad journey. Here are 7 key factors to consider before making your decision.',
    date: 'April 20, 2025',
    category: 'Students',
    readTime: '5 min read',
  },
  {
    title: '5 CRM Features Every Education Consultancy Needs in 2025',
    excerpt: 'From lead tracking to automated follow-ups, discover the essential CRM features that can transform your consultancy operations.',
    date: 'April 15, 2025',
    category: 'Consultancies',
    readTime: '7 min read',
  },
  {
    title: 'Understanding UK Student Visa Requirements: A Complete Guide',
    excerpt: 'Everything Indian students need to know about the UK Tier 4 student visa, from application to approval.',
    date: 'April 10, 2025',
    category: 'Visa Guide',
    readTime: '10 min read',
  },
  {
    title: 'How EzyAbroad AI is Revolutionizing Study Abroad Counseling',
    excerpt: 'Our AI-powered advisor helps students get instant answers to their most pressing study abroad questions.',
    date: 'April 5, 2025',
    category: 'Product',
    readTime: '4 min read',
  },
  {
    title: 'Top 10 Universities in Canada for Indian Students in 2025',
    excerpt: 'A curated list of the best Canadian universities based on rankings, scholarships, and post-study work opportunities.',
    date: 'March 28, 2025',
    category: 'Students',
    readTime: '8 min read',
  },
  {
    title: 'Scaling Your Consultancy: From 10 to 100 Students Per Month',
    excerpt: 'Proven strategies from top-performing consultancies on how to grow your student pipeline efficiently.',
    date: 'March 20, 2025',
    category: 'Consultancies',
    readTime: '6 min read',
  },
];

export default function Blog() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-100">
        <div className="w-full px-4 md:px-8 lg:px-12 py-4">
          <div className="max-w-6xl mx-auto flex items-center justify-between">
            <button onClick={() => navigate('/')} className="text-xl font-bold text-navy-600 cursor-pointer">
              EzyAbroad
            </button>
            <button
              onClick={() => navigate('/')}
              className="text-sm text-gray-500 hover:text-navy-600 cursor-pointer"
            >
              ← Back to Home
            </button>
          </div>
        </div>
      </header>

      <main className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-xs font-semibold tracking-widest text-gold-600 uppercase">Blog</span>
            <h1 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-bold text-navy-600">
              Insights for Students & Consultancies
            </h1>
            <p className="mt-4 text-base text-gray-500 max-w-2xl mx-auto">
              Stay updated with the latest trends, tips, and guides for studying abroad and running a successful consultancy.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {blogPosts.map((post, index) => (
              <article
                key={index}
                className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-md transition-all group cursor-pointer"
              >
                <div className="h-48 bg-gradient-to-br from-navy-100 to-sky-100 flex items-center justify-center">
                  <i className="ri-article-line text-5xl text-navy-300" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs font-medium text-gold-600 bg-gold-50 px-2.5 py-1 rounded-full">
                      {post.category}
                    </span>
                    <span className="text-xs text-gray-400">{post.readTime}</span>
                  </div>
                  <h2 className="text-lg font-semibold text-navy-600 group-hover:text-gold-600 transition-colors line-clamp-2">
                    {post.title}
                  </h2>
                  <p className="mt-2 text-sm text-gray-500 line-clamp-3">{post.excerpt}</p>
                  <div className="mt-4 text-xs text-gray-400">{post.date}</div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
